export default __webpack_public_path__ + "3aa5e616f5dea1739ff70fe23f0c57e4.png";